import type { AppAuthPayload } from 'shared/types'
import { domain } from './_init'

export const reset = domain.createEvent()

export const setFormFields = domain.createEvent<Partial<AppAuthPayload>>()

export const submit = domain.createEvent()
